import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Copy, Box } from '@elparking/components'
import PropTypes from 'prop-types'

const NoPayment = ({label}) => <Box borderRadius='4px' background='warning_light' display='inline-block' padding='4px 8px'>
    <Copy textWrap='no-wrap' as='span' padding='0px' fontSize='xxSmall' fontWeight='book' fontColor='warning_dark' >
        {label}
    </Copy>
</Box>
NoPayment.propTypes = {
    label: PropTypes.node,
}
NoPayment.defaultProps = {
    label: <FormattedMessage defaultMessage='Sin pago por adelantado'/>,
}
export default NoPayment
